import IboxToolsView from "./ibox_tools.html";


angular.module("ibox_tools", [])

/**
 * iboxTools - Directive for iBox tools elements in right corner of ibox
 */
.directive('iboxTools', ['$timeout',function iboxTools($timeout) {
    return {
        restrict: 'A',
        scope: true,
        template: IboxToolsView,
        controller: ['$scope', '$element', function ($scope, $element) {
            // Function for collapse ibox
            $scope.showhide = function () {
                var ibox = $element.closest('div.ibox');
                var icon = $element.find('i:first');
                var content = ibox.find('div.ibox-content');
                content.slideToggle(200);
                // Toggle icon from up to down
                icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
                ibox.toggleClass('').toggleClass('border-bottom');
                $timeout(function () {
                    ibox.resize();
                    ibox.find('[id^=map-]').resize();
                }, 50);
            }
        }]
    };
}])

    /**
 * iboxTools - Directive for iBox tools elements in right corner of ibox
 */
.directive('iboxToolsClosed',['$timeout', function iboxTools($timeout) {
    return {
        restrict: 'A',
        scope: true,
        template: IboxToolsView,
        controller: ['$scope', '$element', function ($scope, $element) {
            // Function for collapse ibox
            $scope.showhide = function () {
                var ibox = $element.closest('div.ibox');
                var icon = $element.find('i:first');
                var content = ibox.find('div.ibox-content');
                content.slideToggle(200);
                // Toggle icon from up to down
                icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
                ibox.toggleClass('').toggleClass('border-bottom');
                $timeout(function () {
                    ibox.resize();
                    ibox.find('[id^=map-]').resize();
                }, 50);
            }
        }]
    };
}])


/**
 * icheck - Directive for custom checkbox icheck
 */
.directive('icheck', ['$timeout', function icheck($timeout) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function($scope, element, $attrs, ngModel) {
            return $timeout(function () {
                var value;
                value = $attrs['value'];

                $scope.$watch($attrs['ngModel'], function (newValue) {
                    ($(element) as any).iCheck('update');
                })

                return ($(element) as any).iCheck({
                    checkboxClass: 'icheckbox_square-yellow',
                    radioClass: 'iradio_square-yellow'

                }).on('ifChanged', function (event) {
                    if ($(element).attr('type') === 'checkbox' && $attrs['ngModel']) {
                        $scope.$apply(function () {
                            return ngModel.$setViewValue((event.target as HTMLInputElement).checked);
                        });
                    }
                    if ($(element).attr('type') === 'radio' && $attrs['ngModel']) {
                        return $scope.$apply(function () {
                            return ngModel.$setViewValue(value);
                        });
                    }
                });
            });
        }
    }
}]);